<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2.37 1.305C1.77899 1.305 1.3 1.78399 1.3 2.375V11.625C1.3 12.216 1.77899 12.695 2.37 12.695H11.63C12.221 12.695 12.7 12.216 12.7 11.625V4.195H12.69V2.375C12.69 1.78399 12.211 1.305 11.62 1.305H2.37ZM13.99 3.775V2.375C13.99 1.06602 12.929 0.00500488 11.62 0.00500488H2.37C1.06101 0.00500488 0 1.06602 0 2.375V11.625C0 12.934 1.06101 13.995 2.37 13.995H11.63C12.939 13.995 14 12.934 14 11.625V3.775H13.99Z"
			fill="#646E87"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M5.05998 4.84501C4.93896 4.84501 4.83998 4.944 4.83998 5.06501V8.93501C4.83998 9.05603 4.93896 9.15501 5.05998 9.15501H8.92998C9.05099 9.15501 9.14998 9.05603 9.14998 8.93501V5.06501C9.14998 4.944 9.05099 4.84501 8.92998 4.84501H5.05998ZM3.53998 5.06501C3.53998 4.22603 4.22099 3.54501 5.05998 3.54501H8.92998C9.76896 3.54501 10.45 4.22603 10.45 5.06501V8.93501C10.45 9.774 9.76896 10.455 8.92998 10.455H5.05998C4.22099 10.455 3.53998 9.774 3.53998 8.93501V5.06501Z"
			fill="#646E87"
		/>
	</svg>
</template>
<script>
export default { name: 'TeamFeaturesSVG' };
</script>
